/* global axios */
import ApiClient from './ApiClient';

// Отчёт по звонкам: свой, потому что отчёты Chatwoot считают диалоги и
// сообщения и про таблицу звонков не знают.
// Час считаем в поясе смотрящего: в UTC «пик в десять утра» у московского клуба
// превратился бы в семь.
const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class CallReportsAPI extends ApiClient {
  constructor() {
    super('call_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  get({ since, until, groupBy, inboxId }) {
    return axios.get(this.url, {
      params: {
        since,
        until,
        group_by: groupBy,
        inbox_id: inboxId,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  download({ since, until, inboxId }) {
    return axios.get(`${this.url}/download`, {
      params: { since, until, inbox_id: inboxId },
    });
  }
}

export default new CallReportsAPI();
